function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Electric_Plug",
  "data-name": "Electric Plug"
}, /*#__PURE__*/React.createElement("path", {
  d: "M39,53h7a3.009,3.009,0,0,0,3-3V41.86A4,4,0,0,0,52,38V35.95A11.011,11.011,0,0,0,62,25V17a3.009,3.009,0,0,0-3-3H58V6a4,4,0,0,0-8,0v8H46V6a4,4,0,0,0-8,0v8H37a3.009,3.009,0,0,0-3,3v8A11.011,11.011,0,0,0,44,35.95V38a4,4,0,0,0,3,3.86V50a1,1,0,0,1-1,1H39a2.995,2.995,0,0,0-2.9,3.74A3.053,3.053,0,0,0,39.11,57H59a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H23a7.008,7.008,0,0,1-7-7V34h9a3.009,3.009,0,0,0,3-3V5a3.009,3.009,0,0,0-3-3H5A3.009,3.009,0,0,0,2,5V31a3.009,3.009,0,0,0,3,3h9V53a9.014,9.014,0,0,0,9,9H59a3.009,3.009,0,0,0,3-3V58a3.009,3.009,0,0,0-3-3H39.11a1.1,1.1,0,0,1-1.08-.75.962.962,0,0,1,.28-.96A.928.928,0,0,1,39,53ZM52,6a2,2,0,0,1,4,0V17H52ZM40,6a2,2,0,0,1,4,0V17H40Zm4.01,27.94A9,9,0,0,1,36,25V17a1,1,0,0,1,1-1h1v2a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16h4v2a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1V16h1a1,1,0,0,1,1,1v8a9,9,0,0,1-8.01,8.94,3.99,3.99,0,0,0-7.98,0ZM46,38V34a2,2,0,0,1,4,0v4a2,2,0,0,1-4,0ZM5,32a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H25a1,1,0,0,1,1,1V31a1,1,0,0,1-1,1Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 35,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.85,15.47A1,1,0,0,0,21,15H16V8a1,1,0,0,0-.77-.97.984.984,0,0,0-1.12.52l-6,12A1,1,0,0,0,9,21h5v7a1,1,0,0,0,.77.97A.908.908,0,0,0,15,29a1,1,0,0,0,.89-.55l6-12A1.007,1.007,0,0,0,21.85,15.47ZM16,23.76V20a1,1,0,0,0-1-1H10.62L14,12.24V16a1,1,0,0,0,1,1h4.38Z"
}));

function SvgElectric(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.fb169998.svg";
export { ForwardRef as ReactComponent };